<div class="eco-json-editor">
  <div class="modal-body">
    <json-editor [options]="editorOptions" [data]="jsonData" #jsonEditor>
    </json-editor>
  </div>
</div>
